var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#2B8BFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9585 14.917C13.2493 14.917 15.917 12.2493 15.917 8.9585C15.917 5.66771 13.2493 3 9.9585 3C6.66771 3 4 5.66771 4 8.9585C4 9.91168 4.22381 10.8125 4.62175 11.6115C4.7275 11.8238 4.76269 12.0665 4.70139 12.2956L4.34649 13.622C4.19243 14.1978 4.7192 14.7245 5.29499 14.5705L6.62138 14.2156C6.8505 14.1543 7.09318 14.1895 7.30549 14.2952C8.10443 14.6932 9.00532 14.917 9.9585 14.917Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20898 9.02464L9.04237 10.6087L12.7091 7.30859",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswered);
export default __webpack_public_path__ + "static/media/answered.70c97946887c1dcdc8baf4164d0c644d.svg";
export { ForwardRef as ReactComponent };